/* eslint-disable arrow-body-style */

import React from 'react';
import classnames from 'classnames';
import { Switch, SwitchProps, CheckChangeContext } from 'tea-component';
import { MilestoneDateStatus } from '@gp/enums/milestone';

import type { IBaseProps } from '@home/types/common';

type ISwitchOthersProps = Omit<SwitchProps, 'children' | 'value' | 'onChange'>;

interface IMilestoneTBCSwitchProps extends IBaseProps, ISwitchOthersProps {
  value?: MilestoneDateStatus;
  onChange?: (payload: MilestoneDateStatus, context: CheckChangeContext) => void;
}

/**
 * TBC的value格式转换
 * 前端组件Switch需要的是boolean，后端接口入参，及返回Milestone数据的TBC是1、2（1代表Confirm、2代表TBC）
 */
export const TBCConvertors = {
  // 转换为boolean类型，前端组件Switch需要的值
  boolean: (payload?: MilestoneDateStatus): boolean => {
    return payload !== void 0 && payload === MilestoneDateStatus.ToBeConfirm;
  },
  // 转换为MilestoneDateStatus枚举类型，后端需要的值
  enums: (payload?: boolean): MilestoneDateStatus => {
    return !!payload ? MilestoneDateStatus.ToBeConfirm : MilestoneDateStatus.Confirm;
  },
};

const MilestoneTBCSwitch: React.FC<IMilestoneTBCSwitchProps> = (props) => {
  const { style, className, value, onChange, ...restProps } = props;

  return (
    <Switch
      {...restProps}
      style={style}
      className={classnames('dbg-milestone__tbc-switch', className)}
      value={TBCConvertors.boolean(value)}
      onChange={(payload, ...args) => {
        onChange?.(TBCConvertors.enums(payload), ...args);
      }}
    />
  );
};

export default MilestoneTBCSwitch;
